<div class="wig-will-writer-powered-by-overlay">
  <!-- <span class="white-text">Powered by...</span> -->
  <img src="assets/logos/churchers-logo.jpg" class="wig-will-writer-powered-by" />
</div>
